/**
 * Verbatim mirror of `ALLERGEN_FLAG_CONFLICTS` in backend/api/helpers/allergenFlagConflicts.ts,
 * which switches these claims off on save; change both together. is_halal has no entry.
 */
export const ALLERGEN_FLAG_CONFLICTS: Record<string, string[]> = {
	is_gluten_free: ["gluten", "cereals", "wheat"],
	is_nut_free: [
		"peanuts",
		"treenuts",
		"nuts",
		"almond",
		"cashew",
		"brazil nut",
		"hazelnut",
		"macadamia",
		"pecan",
		"pine nut",
		"pistachio",
		"walnut",
		"peanut",
	],
	is_dairy_free: ["milk", "lactose", "dairy"],
	is_vegan: ["milk", "lactose", "dairy", "eggs", "fish", "crustaceans", "molluscs"],
	is_vegetarian: ["fish", "crustaceans", "molluscs"],
}
